import { Controller } from '@hotwired/stimulus'
import { emiteEventoDelEmbudo } from 'lib/analitica_del_embudo'

// Connects to data-controller="analitica-clic".
//
// Mide el clic en un enlace o botón con un evento de GA4, sin parámetros propios:
//
//   %a{ data: { controller: 'analitica-clic', 'analitica-clic-evento-value': 'home_manage_subscriptions_click',
//               action: 'click->analitica-clic#emite' } }
//
// Lo usa «Gestiona tus suscripciones» de la home personalizada (US-147-2.3.1, plan de medición del
// PRD147-2). Para un clic que necesite contexto propio (qué newsletter, qué paso), mejor un
// controlador que lo construya, como `fuente_preferida_controller`.
//
// Mecanismo: `emiteEventoDelEmbudo` → `dataLayer` → GTM → GA4, con las propiedades comunes
// (`user_id`, `locale`, utm…) que publica el servidor y su guarda de PII. Sin contexto publicado
// (`ANALITICA_EMBUDO=false`) no emite nada.
export default class extends Controller {
  static values = { evento: String }

  // Ni cancela ni detiene el clic: el enlace tiene que navegar igual, mida o no mida. Y no hace
  // falta envolverlo en un `try`: `emiteEventoDelEmbudo` nunca lanza.
  emite () {
    emiteEventoDelEmbudo(this.eventoValue)
  }
}
